import BackgroundOption1 from '../../assets/images/backgrounds/option1.png';
import BackgroundOption2 from '../../assets/images/backgrounds/option2.png';
import { THEME_COLORS } from '../common/colors';

export const BACKGROUNDS = [
  {
    background: BackgroundOption1,
    buttonColor: '#D25525',
    buttonText: '#fff',
    hoverColor: THEME_COLORS.primaryHover,
    header: 'Your time is your most valuable asset',
  },
  {
    background: BackgroundOption2,
    buttonColor: '#9bb534',
    buttonText: '#000',
    hoverColor: '#9bb534',
    header: 'Take your hobbies to the next level',
  },
];
